import React, {Component} from 'react'
import {withRouter} from "react-router-dom"
import BroadTermsPageUI from "./BroadTermsPageUI"
import RestApiUtils from "../../../apiclient/moebli/RestApiUtils"

class BroadTermsPageSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      successMsg: null,
      errorList: null,
      loan: null,
    }
  }

  render() {
    return (
      <BroadTermsPageUI
        context={this.props.context}
        errorList={this.state.errorList}
        loan={this.state.loan}
      />
    )
  }

  componentDidMount() {
    this.getLoan(this.props.context)
  }

  getLoan(context) {
    RestApiUtils.get(
      this.props.context,
      `/api/su/loans/${this.props.match.params.loanId}`,
      this.getLoanCallback
    )
  }

  getLoanCallback = (response) => {
    this.setState({
      errorList: response.errorList,
      loan: response.loan,
    })
  }
}

export default withRouter(BroadTermsPageSF)


